"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../Icons");
var IconButton_styles_1 = require("./IconButton.styles");
exports.default = (function (_a) {
    var ButtonSize = _a.ButtonSize, OnClick = _a.OnClick, IconName = _a.Icon, IconSize = _a.IconSize, AriaLabel = _a.AriaLabel, ShowBackground = _a.ShowBackground, Disabled = _a.Disabled, Color = _a.Color, Title = _a.Title;
    var _b = React.useState(false), IsHovered = _b[0], SetIsHovered = _b[1];
    var buildStyleProps = function () {
        var color;
        if (ShowBackground) {
            color = IsHovered ? IconButton_styles_1.HOVER_COLOR_SHOW_BACKGROUND_TRUE : Color ? Color : IconButton_styles_1.DEFAULT_COLOR;
        }
        else {
            color = IsHovered ? IconButton_styles_1.DEFAULT_HOVER_COLOR : Color ? Color : IconButton_styles_1.DEFAULT_COLOR;
        }
        return {
            BackgroundColor: !ShowBackground ? "transparent" : IsHovered ? IconButton_styles_1.BACKGROUND_HOVER_COLOR : IconButton_styles_1.BACKGROUND_COLOR,
            Color: color,
            Height: ButtonSize,
            Width: ButtonSize,
        };
    };
    return (React.createElement(IconButton_styles_1.default, __assign({}, buildStyleProps(), { onClick: OnClick, type: "button", "aria-label": AriaLabel, title: Title, disabled: Disabled, onMouseEnter: function () { return SetIsHovered(true); }, onMouseLeave: function () { return SetIsHovered(false); } }),
        React.createElement(Icons_1.Icon, { Height: IconSize, Width: IconSize, Icon: IconName })));
});
